import { MeetingData } from 'utils';
import { create } from 'zustand';

export interface VideoCallState {
  meetingData: MeetingData | null;
  appointmentId: string | null;
}

const VIDEO_CALL_STATE_INITIAL: VideoCallState = {
  meetingData: null,
  appointmentId: null,
};

export const useVideoCallStore = create<VideoCallState>()(() => ({
  ...VIDEO_CALL_STATE_INITIAL,
}));
